import React, { useState, useEffect } from "react";
import { Line } from "react-chartjs-2";

//Material UI Components
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";

import BaseLayout from "../components/BaseLayout/index";
import NftContainer from "../components/NftContainerBuySell/NftContainer";

import SwitchButton from "../components/SwitchButton/index";
import { Card } from "@material-ui/core";
import { Typography } from "@material-ui/core";
import { CardContent } from "@material-ui/core";
import { Divider } from "@material-ui/core";
import { CardActionArea } from "@material-ui/core";
import { Button } from "@material-ui/core";
import { TextField } from "@material-ui/core";

import { useWallet } from "../context/walletProvider";
//import FractionalTokenABI from "../contracts/abi/FractionalToken";
import FractionalTokenABI from "../contracts/abi/FractionalToken";
import { useHistory, useParams } from "react-router-dom";
import {
  buyFraction,
  sellFraction,
  balanceOf,
  getTokenDetails,
  getEthBalance,
  initiateBuyout,
  cancelBuyout,
  getWinner,
  unlock,
} from "../components/web3Wrapper";
//web3

const useStyles = makeStyles(({ breakpoints, spacing }, theme) => ({
  root: {
    flexGrow: 1,
    //background: "#000714",
  },
  title: {
    fontSize: 14,
  },
}));

const state = {
  labels: ["JUN 14", "JUN 15", "JUN 16", "JUN 17", "JUN 18"],
  datasets: [
    {
      label: "Price",
      fill: false,
      lineTension: 0.5,
      backgroundColor: "#fff",
      borderColor: "#fff",
      borderWidth: 2,
      data: [2, 5, 15, 55, 120],
    },
  ],
};

function NFTBuySell() {
  const classes = useStyles();
  const wallet = useWallet();
  const history = useHistory();
  let { nonce, id } = useParams();
  console.log(id);

  const [screen, setScreen] = useState("buy");
  const [amount, setAmount] = useState(0);
  const [balance, setBalance] = useState(0);
  const [ethBalance, setEthBalance] = useState(0);
  const [name, setName] = useState();
  const [symbol, setSymbol] = useState();
  const [isBuyout, setIsBuyout] = useState(false);
  const [winner, setWinner] = useState(null);
  const [bidAmount, setBidAmount] = useState(null);
  const [supply, setSupply] = useState(null);
  const [reserveBalance, setReserveBalance] = useState(0);
  const [ownerPercentage,setOwnerPercentage] = useState(0)
  const handleTrade = async () => {
    wallet.setLoadingState(true);
    const FXNContractInstance = new wallet.web3.eth.Contract(
      FractionalTokenABI,
      id
    );
    let receipt;
    //const screen = "buy";
    if (screen === "buy") {
      receipt = await buyFraction(id, amount * 1e18, wallet.account);
      console.log(receipt);
      wallet.setUpdateFlag();
    } else if (screen === "sell") {
      const amount_bn = amount * 1e18;
      console.log(amount_bn.toLocaleString("fullwide", { useGrouping: false }));
      receipt = await sellFraction(
        id,
        amount_bn.toLocaleString("fullwide", { useGrouping: false }),
        wallet.account
      );
      console.log(receipt);
      wallet.setUpdateFlag();
      console.log("Calling the sell contract method", amount * 1e18);
    }
    wallet.setLoadingState(false);
  };
  const handleBuyoutInit = async () => {
    wallet.setLoadingState(true);
    await initiateBuyout(nonce, wallet.account);
    wallet.setLoadingState(false);
  };

  const handleCancel = async () => {
    wallet.setLoadingState(true);
    await cancelBuyout(nonce, wallet.account);
    wallet.setLoadingState(false);
  };
  const handleUnlock = async () => {
    wallet.setLoadingState(true);
    await unlock(nonce, wallet.account);
    wallet.setLoadingState(false);
  };
  const handleToggle = () => {
    if (screen === "sell") {
      setScreen("buy");
    } else {
      setScreen("sell");
    }
    console.log(screen);
  };
  useEffect(() => {
    async function fetchFractionalBalance() {
      const bal = await balanceOf(id, wallet.account);

      setBalance(bal);
      const details = await getTokenDetails(id, wallet.account);
      const winner = await getWinner(nonce);
      console.log("winner", winner);
      const ethBal = await getEthBalance(wallet.account);
      const resBalance = await getEthBalance(id);
      console.log("reserveBalance", resBalance);
      if (winner != "0x0000000000000000000000000000000000000000") {
        const winnerBalance = await balanceOf(id, winner);
        setWinner(winner);
        setOwnerPercentage((parseFloat(winnerBalance) / details.supply *100).toFixed(2));
      }
      setName(details.name);
      setSymbol(details.symbol);
      setSupply(details.supply);
      setEthBalance(ethBal);
      setReserveBalance(resBalance);
      if (bal > 0.2 * details.supply) {
        setIsBuyout(true);
      }
    }
    if (wallet.status === "connected") {
      fetchFractionalBalance();
    }
  }, [wallet,isBuyout,winner,balance]);
  return (
    <BaseLayout className={classes.root} style={{ marginBottom: "10%" }}>
      <div style={{ backgroundColor: "black", backdropFilter: "blur(43px)" }}>
        <Grid
          container
          spacing={10}
          style={{ marginTop: "0%", width: "80%", margin: "auto" }}
        >
          <span className="token-name">{name}</span>
          <div className="token-details">
            <div className="token-details-box">
              Price
              <br />
              {/* TODO fetch ether balance of contract */}
              <span>{(reserveBalance / (supply * 0.3)).toFixed(8)}</span>ETH
            </div>
            <div className="token-details-box">
              Valuation
              <br />
              <span>{(reserveBalance / 0.3 / 1e18).toFixed(3)} </span>ETH
            </div>
            <div className="token-details-box">
              Supply
              <br />
              <span>{(supply / 1e18).toFixed(3)}</span>
            </div>
            <div className="token-details-box">
              Reserve
              <br />
              <span>{(reserveBalance / 1e18).toFixed(3)} </span>ETH
            </div>
            <div className="token-details-box">
              Min. Buyout
              <br />
              <span>20%</span>
            </div>
          </div>
          <Grid item xs={7} style={{ padding: "0", marginTop: "10vh" }}>
            <Line
              data={state}
              options={{
                title: {
                  display: true,
                  text: "Average Rainfall per month",
                  fontSize: 20,
                },
                legend: {
                  display: true,
                  position: "right",
                },
              }}
            />
          </Grid>
          <Grid item xs={5}>
            <Card
              style={{
                backgroundColor: "#0E0E0E",
                backdropFilter: "blur(43px)",
                maxWidth: "370px",
              }}
            >
              <CardContent style={{ textAlign: "center" }}>
                <SwitchButton
                  style={{ marginBottom: "10%" }}
                  handleToggle={handleToggle}
                />

                <Grid container spacing={0} style={{ marginBottom: "5%" }}>
                  <Grid item xs={3}>
                    <div style={{ float: "left", color: "grey" }}>ETH</div>
                  </Grid>
                  <Grid item xs={9}>
                    <div style={{ float: "right", color: "white" }}>
                      {ethBalance / 1e18} ETH
                    </div>
                  </Grid>
                </Grid>
                <Grid container spacing={0} style={{ marginBottom: "5%" }}>
                  <Grid item xs={3}>
                    <div style={{ float: "left", color: "grey" }}>{symbol}</div>
                  </Grid>
                  <Grid item xs={9}>
                    <div style={{ float: "right", color: "white" }}>
                      {balance / 1e18} {symbol}
                    </div>
                  </Grid>
                </Grid>
                <Divider
                  //variant='middle'
                  style={{ backgroundColor: "white", marginBottom: "5%" }}
                />
                <Grid container spacing={0} style={{ marginBottom: "5%" }}>
                  <Grid item xs={6}>
                    <div style={{ float: "left", color: "grey" }}>PRICE</div>
                  </Grid>
                  <Grid item xs={6}>
                    <div style={{ float: "right", color: "white" }}>
                      {(reserveBalance / (0.3 * supply)).toFixed(10)} ETH
                    </div>
                  </Grid>
                </Grid>
                <Grid container spacing={0} style={{ marginBottom: "5%" }}>
                  <Grid item xs={6}>
                    <div style={{ float: "left", color: "grey" }}>SLIPPAGE</div>
                  </Grid>
                  <Grid item xs={6}>
                    <div style={{ float: "right", color: "white" }}>0.00%</div>
                  </Grid>
                </Grid>
                <Grid container spacing={0} style={{ marginBottom: "10%" }}>
                  <Grid item xs={6}>
                    <div
                      style={{
                        float: "left",
                        color: "grey",
                        marginTop: "5px",
                      }}
                    >
                      AMOUNT({screen == "buy" ? "ETH" : symbol})
                    </div>
                  </Grid>
                  <Grid item xs={6}>
                    <div style={{ float: "right", color: "white" }}>
                      <TextField
                        size="small"
                        style={{
                          width: "100%",
                          backgroundColor: "white",
                          color: "white",
                          borderRadius: "10px",
                          multilineColor: "white",
                          //height: "1%",
                          //height: "35px",
                          //marginBottom: "30px",
                        }}
                        //label='Name'
                        variant="outlined"
                        InputLabelProps={{ className: "text-label" }}
                        value={amount}
                        onChange={(e) => {
                          setAmount(e.target.value);
                        }}
                      />
                    </div>
                  </Grid>
                </Grid>
              </CardContent>
              <CardActionArea style={{ textAlign: "center" }}>
                {screen === "buy" ? (
                  <Button
                    style={{
                      borderRadius: "30px",
                      boxShadow: "0px 9px 14px rgba(255, 255, 255, 0.2)",
                      fontSize: ".7rem",
                      marginLeft: "0%",
                      marginBottom: "10%",
                      fontWeight: "bold",
                    }}
                    variant="contained"
                    size="large"
                    onClick={handleTrade}
                  >
                    Buy Fraction
                  </Button>
                ) : (
                  <Button
                    style={{
                      borderRadius: "30px",
                      boxShadow: "0px 9px 14px rgba(255, 255, 255, 0.2)",
                      fontSize: ".7rem",
                      marginLeft: "0%",
                      marginBottom: "10%",
                      fontWeight: "bold",
                    }}
                    variant="contained"
                    size="large"
                    onClick={handleTrade}
                  >
                    Sell Fraction
                  </Button>
                )}
              </CardActionArea>
            </Card>
          </Grid>
          {isBuyout ? (
            <div className="buyout-content">
              {winner ? (
                <>
                  {winner == wallet.account ? (
                    <div>
                    <h3>Your Percentage: {ownerPercentage}</h3>
                    <Button
                      style={{
                        borderRadius: "30px",
                        boxShadow: "0px 9px 14px rgba(255, 255, 255, 0.2)",
                        fontSize: ".7rem",
                        fontWeight: "bold",
                        marginTop: "20px",
                      }}
                      variant="contained"
                      size="large"
                      onClick={handleUnlock}
                    >
                      Unlock
                    </Button>
                    </div>
                  ) : (
                    <div>
                    <h3>Your Percentage: {(parseFloat(balance)/supply *100).toFixed(2)}</h3>
                    <Button
                      style={{
                        borderRadius: "30px",
                        boxShadow: "0px 9px 14px rgba(255, 255, 255, 0.2)",
                        fontSize: ".7rem",
                        fontWeight: "bold",
                        marginTop: "20px",
                      }}
                      variant="contained"
                      size="large"
                      onClick={handleCancel}
                    >
                      Cancel Buyout
                    </Button>
                    </div>
                  )}
                </>
              ) : (
                <div>
                    <h3>Your Percentage: {(parseFloat(balance)/supply *100).toFixed(2)}</h3>
                  <Button
                    style={{
                      borderRadius: "30px",
                      boxShadow: "0px 9px 14px rgba(255, 255, 255, 0.2)",
                      fontSize: ".7rem",
                      marginLeft: "0%",
                      fontWeight: "bold",
                      marginTop: "20px",
                    }}
                    variant="contained"
                    size="large"
                    onClick={handleBuyoutInit}
                  >
                    Init Buyout
                  </Button>
                  </div>
              )}
            </div>
          ) : (
            <span style={{ color: "#E0E0E0" }}>
              Your Percentage: {(parseFloat(balance)/supply *100).toFixed(2)}. Need more tokens to initiate buyout.
            </span>
          )}
        </Grid>
        <Grid container style={{ marginTop: "0%" }}>
          <Grid item xs={12} style={{ padding: "10vh" }}></Grid>
        </Grid>
      </div>
    </BaseLayout>
  );
}

export default NFTBuySell;
